import styled from '@emotion/styled';
import { Palette, Typography } from '@mui/material';

// Container

export interface ContainerProps {
  color: keyof Palette;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: var(--card-layout-content-padding);
  color: ${p => p.theme.palette[p.color].main};
`;

// Text

export const Text = styled(Typography)`
  text-transform: uppercase;
  font-weight: bold;
  align-items: center;
`;

Text.defaultProps = {
  variant: 'body2',
};
